/** @jsx jsx */
import * as React from "react";
import { jsx, useColorMode, Box } from "theme-ui";

import Button from "./Button";
import theme from "../gatsby-plugin-theme-ui";

const themes = ["light", ...Object.keys(theme.colors.modes)];

interface ThemeSwitcherProps {
  className?: string;
}

const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ className }) => {
  const [colorMode, setColorMode] = useColorMode();
  return (
    <Box className={className}>
      <Button
        sx={{
          variant: "buttons.transparent",
          borderRadius: "2px",
          textTransform: "capitalize",
        }}
        onClick={() => {
          const index = themes.indexOf(colorMode);
          const next = themes[(index + 1) % themes.length];
          setColorMode(next);
        }}
      >
        {`${colorMode} mode`}
      </Button>
    </Box>
  );
};

export default ThemeSwitcher;
